import { useEffect, useState } from 'react';
import { axiosInstance, StatCard } from './_shared';

export default function DashboardTab({ isSuperAdmin, setTab }) {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    axiosInstance.get('/admin/dashboard').then(r => setStats(r.data)).catch(() => {});
  }, []);

  if (!stats) return <div className="flex justify-center py-20"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#E54562]" /></div>;
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-3">
        <StatCard icon="ph-users" label="Total Users" value={stats.users} color="bg-blue-50 text-blue-800" />
        <StatCard icon="ph-calendar-check" label="Active Events" value={stats.events} color="bg-green-50 text-green-800" />
        <StatCard icon="ph-ticket" label="Bookings" value={stats.bookings} color="bg-purple-50 text-purple-800" />
        <StatCard icon="ph-shopping-bag" label="Orders" value={stats.orders} color="bg-yellow-50 text-yellow-800" />
        <StatCard icon="ph-clock" label="Pending Apps" value={stats.pending_applications} color="bg-orange-50 text-orange-800" />
        <StatCard icon="ph-calendar-blank" label="Upcoming" value={stats.upcoming_events} color="bg-teal-50 text-teal-800" />
      </div>
      <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
        <p className="text-xs uppercase tracking-widest text-gray-400 mb-4">Quick Actions</p>
        <div className="grid grid-cols-2 gap-3">
          {[
            { label: 'Manage Events', icon: 'ph-calendar', tab: 3 },
            { label: 'Review Applications', icon: 'ph-clipboard-text', tab: 2 },
            { label: 'Manage Shop', icon: 'ph-storefront', tab: 4 },
            { label: 'View Registrations', icon: 'ph-list-bullets', tab: 5 },
          ].concat(isSuperAdmin ? [{ label: 'Manage Users', icon: 'ph-users-three', tab: 1 }] : []).map(a => (
            <button key={a.tab} onClick={() => setTab(a.tab)}
              className="flex items-center gap-2 px-3 py-3 rounded-xl bg-gray-50 border border-gray-100 text-sm font-bold text-[#2B3A67] hover:bg-[#2B3A67] hover:text-white transition-colors">
              <i className={`ph-bold ${a.icon}`} />{a.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
